class Carousel {
  constructor() {
    this.initOwlCarousel();
  }

  initOwlCarousel() {
    jQuery(document).ready(function($){
      $(".owl-carousel-3").owlCarousel({
        items: 3,
        dots: true,
        nav: true,
        navText: ["<i class='fa fa-chevron-left'></i>", "<i class='fa fa-chevron-right'></i>"],
        responsive: {
          0: {
            items: 1
          },
          768: {
            items: 2
          },
          992: {
            items: 3
          },
          1200: {
            items: 3
          }
        }
      });

      $(".owl-carousel-4").owlCarousel({
        items: 4,
        dots: true,
        nav: true,
        navText: ["<i class='fa fa-chevron-left'></i>", "<i class='fa fa-chevron-right'></i>"],
        responsive: {
          0: {
            items: 1
          },
          768: {
            items: 2
          },
          992: {
            items: 3
          },
          1200: {
            items: 4
          }
        }
      });
    });
  }
}

export default Carousel;
